import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "Smart Educare Center - Best Preschool & Daycare in Badlapur",
  description = "Smart Educare Center offers premium preschool, daycare, personalized coaching, and sanskar varg in Badlapur. Expert teachers, modern facilities, and holistic child development. Call +91 9834387679",
  keywords = "preschool badlapur, daycare badlapur, smart educare center, personalized coaching, sanskar varg, counseling services, early childhood education, katrap badlapur, quality education, child development",
  image = "/logo512.png",
  url = "https://smarteducarecentre.vercel.app",
  type = "website"
}) => {
  const siteUrl = "https://smarteducarecentre.vercel.app";
  const fullUrl = url.startsWith('http') ? url : `${siteUrl}${url}`;
  const fullImageUrl = image.startsWith('http') ? image : `${siteUrl}${image}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content="Smart Educare Center" />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph Meta Tags */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImageUrl} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:site_name" content="Smart Educare Center" />
      <meta property="og:locale" content="en_IN" />

      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImageUrl} />

      {/* Additional SEO Meta Tags */}
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      <meta name="distribution" content="global" />
      <meta name="rating" content="general" />
      <meta name="geo.region" content="IN-MH" />
      <meta name="geo.placename" content="Badlapur, Maharashtra" />
      <meta name="geo.position" content="19.1704;73.2673" />
      <meta name="ICBM" content="19.1704, 73.2673" />
    </Helmet>
  );
};

export default SEO;
